import { render } from "./mensagens.vue?vue&type=template&id=db66a35a"
import script from "./mensagens.vue?vue&type=script&lang=js"
export * from "./mensagens.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__